import layout from '@/components/layout/layout'
import {localLanguageVal} from "@/utils/autoScale";
let localLanguage=localLanguageVal()
const contact = {
  path: '',
  name: 'contact',
    redirect: '',
  component: layout,
  children: [{
    path: localLanguage+'/contact',
    redirect: '',
      name: 'contact',
    component: () => import('@/views/contact/index')
  },{
      path: localLanguage+'/problem',
      redirect: '',
      name: 'contact',
      component: () => import('@/views/contact/problem')
  }]
}

export default contact
